"use client";

export function StarField() {
  return <div className="starfield" aria-hidden="true" />;
}
